import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installE2EVisualReview } from './e2eVisualReview';
import { applyTextSizeToDocument, readStoredTextSize } from './utils/textSize';

applyTextSizeToDocument(readStoredTextSize());

if (process.env.REACT_APP_E2E_VISUAL_REVIEW === '1') {
  installE2EVisualReview();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
